export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref11944.b22547dd.jpg";